import { memo } from 'react';
import { splitPrice, type PriceDirection } from './priceFormat';

/** A price with MT5-style emphasis. A new tick restarts a short flash (a remount via `tick`), plus an arrow for the direction. */
export const PriceCell = memo(function PriceCell({
  value,
  digits,
  tick,
  direction,
  label,
}: {
  value: number;
  digits: number;
  tick: number;
  direction: PriceDirection;
  label: string;
}) {
  const parts = splitPrice(value, digits);
  const flash = direction === 'up' ? 'flash-up' : direction === 'down' ? 'flash-down' : '';
  return (
    <span
      key={tick}
      className={`price-cell num inline-flex items-baseline justify-end rounded-sm px-1 ${flash}`}
      aria-label={`${label} ${value.toFixed(digits)}`}
    >
      <span>{parts.main}</span>
      <span className="text-[1.25em] font-semibold">{parts.big}</span>
      <sup className="text-[0.75em]">{parts.small}</sup>
    </span>
  );
});
